/**
 *
 *  Apple Login
 *  Component
 *
 *  Created by Vladimir Shishlyannikov on 09/05/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import PropTypes from "prop-types"; // use directly
import { toQueryString } from "../../utils";

import Apple from "./Apple";

class AppleLogin extends React.Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    redirectURI: PropTypes.string.isRequired,
    stateFrom: PropTypes.string,
    autoLoad: PropTypes.bool,
    scope: PropTypes.string,
    state: PropTypes.string,
    responseType: PropTypes.string, // | "code" | "id_token",
    responseMode: PropTypes.string, // | "query" | "fragment" | "form_post",
    nonce: PropTypes.string,
    designProp: PropTypes.shape({
      // REF: PropTypes.https://developer.apple.com/documentation/signinwithapplejs/incorporating_sign_in_with_apple_into_other_platforms
      height: PropTypes.number,
      width: PropTypes.number,
      color: PropTypes.string, // | "white" | "black",
      border: PropTypes.bool,
      type: PropTypes.string, // | "sign-in" | "continue",
      border_radius: PropTypes.number,
      scale: PropTypes.number,
      locale: PropTypes.string,
    }),
    size: PropTypes.string,
    callback: PropTypes.func, // (d: PropTypes.any) =PropTypes.> void,
    onClick: PropTypes.func, // (e?: PropTypes.any) =PropTypes.> void,
    disabled: PropTypes.bool,
  };

  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);

    this.state = {};
  }

  componentDidMount() {
    const {
      responseMode = "query",
      responseType = "code",
      callback,
      autoLoad = false,
    } = this.props;

    if (autoLoad) {
      this.onClick();
    }

    if (
      typeof callback === "function" &&
      // responseMode === 'query' &&
      // responseType === 'code' &&
      window &&
      window.location
    ) {
      const urlParams = getUrlParams();

      if (urlParams["identityToken"] && urlParams["authorizationCode"]) {
        callback({
          identityToken: urlParams["identityToken"],
          authorizationCode: urlParams["authorizationCode"],
        });
      }
    }
  }

  render() {
    const { className, disabled, designProp } = this.props;

    return (
      <button
        id="appleid-signin"
        className={`${className} tbk-flex tbk-justify-center tbk-rounded-lg tbk-bg-basic-trueblack tbk-text-basic-white hover:tbk-border-grey-main hover:tbk-bg-grey-main hover:tbk-text-basic-white focus:tbk-border-grey-main focus:tbk-bg-grey-main focus:tbk-text-basic-white active:tbk-border-grey-main active:tbk-bg-grey-main active:tbk-text-basic-white disabled:tbk-border-grey-main disabled:tbk-bg-grey-main disabled:tbk-text-blue-grey`}
        style={{
          padding: "15px 0",
        }}
        disabled={disabled}
        onClick={this.onClick}
      >
        <Apple className="tbk-mr-1" />
        {this.props.size !== "small" ? "Apple" : ""}
        {/*<img className='img-responsive' src={`https://appleid.cdn-apple.com/appleid/button?${toQueryString(
                    designProp
                )}`} />*/}
      </button>
    );
  }

  onClick(e = null) {
    const {
      clientId,
      redirectURI,
      returnTo,
      stateFrom,
      state = "",
      responseMode = "query",
      responseType = "code",
      nonce,
      scope,
    } = this.props;

    if (e) {
      e.preventDefault();
    }

    // window.open(
    //   `https://appleid.apple.com/auth/authorize?${toQueryString({
    //     response_type: responseType,
    //     response_mode: responseMode,
    //     client_id: clientId,
    //     redirect_uri: redirectURI,
    //     state,
    //     nonce,
    //     scope: responseMode === "query" ? "" : scope,
    //   })}`,
    //   "_blank"
    // );

    if (returnTo) {
      // When logging in with PrivateRoute
      let returnToUrl =
        typeof returnTo === "object" ? returnTo.pathname : returnTo;
      window.localStorage.setItem("apple-redirect-return-to", returnToUrl);
    }

    if (stateFrom) {
      // When logging in with PrivateRoute
      let stateFromValue =
        typeof stateFrom === "object" ? stateFrom.pathname : stateFrom;
      window.localStorage.setItem("apple-redirect-state-from", stateFromValue);
    }

    window.location.href = `https://appleid.apple.com/auth/authorize?${toQueryString(
      {
        response_type: responseType,
        response_mode: responseMode,
        client_id: clientId,
        redirect_uri: redirectURI,
        state,
        nonce,
        scope: responseMode === "query" ? "" : scope,
      }
    )}`;
  }
}

function getUrlParams() {
  let match;
  const pl = /\+/g, // Regex for replacing addition symbol with a space
    search = /([^&=]+)=?([^&]*)/g,
    decode = (s) => {
      return decodeURIComponent(s.replace(pl, " "));
    },
    query = window.location.search.substring(1);

  let urlParams = {};

  while ((match = search.exec(query))) {
    urlParams[decode(match[1])] = decode(match[2]);
  }

  return urlParams;
}

export default AppleLogin;
